import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentToSignHistoryModel } from '../../models/documentToSignHistoryModel';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckSignedDocumentService {

  constructor(private http: HttpClient) {
  }

  getDocumentHistory(documentToSignID: string): Observable<DocumentToSignHistoryModel[]> {
    return this.http.get<DocumentToSignHistoryModel[]>(`${environment.apiServer.webApiURL}/CheckSignedDocument/${encodeURIComponent(documentToSignID)}`);
  }

  canEmailClients(documentToSignID: string): Observable<boolean> {
    return this.http.get<boolean>(`${environment.apiServer.webApiURL}/CheckSignedDocument/${encodeURIComponent(documentToSignID)}/EmailAccess`);
  }

  emailClients(documentToSignID: string): Observable<string> {
    return this.http.post(`${environment.apiServer.webApiURL}/CheckSignedDocument/${encodeURIComponent(documentToSignID)}/EmailAccess`, {}, { responseType: 'text' });
  }
}
